module.exports = __webpack_public_path__ + "static/media/Partner-LogosTanamera.f0b26636.png";